/* BUY DRAWER (15.10.2026) — [data-buy-drawer] otwiera dolny panel: szybkie podsumowanie,
   opcja „zamień na zestaw" (Family + etui StethoCase, 49 zł zamiast 79 zł — kod StethoMeZestaw)
   i „Akceptuję i przechodzę do płatności".

   Po kliknięciu „Akceptuję…":
     1. czyści koszyk i dodaje wybrane produkty (kup-teraz = tylko to, co w panelu),
     2. zapisuje na koszyku atrybuty — Shopify kopiuje je na zamówienie (Additional details):
          "Regulamin zaakceptowany"          = znacznik czasu UTC (ISO 8601),
          "Regulamin zaakceptowany (źródło)" = skąd (Shopify – strona główna),
          "Wariant zamówienia"               = Family albo Zestaw,
     3. przechodzi do /checkout (dla zestawu przez /discount/StethoMeZestaw).
   Zapis po stronie przeglądarki — pomocniczy ślad, nie dowód odporny na manipulację. */
(function () {
  const DEFAULTS = { family: 47685374345562, familyPrice: 989, familyImage: "" };
  const CASE_VARIANT = 48460084805978, CASE_PRICE = 49, CASE_LIST = 79;
  const DISCOUNT = "StethoMeZestaw";
  const IMG_CASE = "https://cdn.prod.website-files.com/670583a0f72a1a1211696379/6938bc7f9f99426cf9f98a53_product-item-thumbnail-4.avif";
  const IMG_FAMILY_FALLBACK = "https://cdn.prod.website-files.com/670583a0f72a1a1211696379/69431c515017e5530de01584_StethoMe_gallery_top_side.avif";
  const zl = (n) => n.toLocaleString("pl-PL") + " zł";

  let cfg = { ...DEFAULTS, source: "Shopify – strona główna" };
  let drawer, upsell, total, errorEl, acceptBtn, returnFocus = null;

  function build() {
    const wrap = document.createElement("div");
    wrap.innerHTML = `
      <div class="buydrawer" id="buyDrawer" hidden>
        <div class="buydrawer__backdrop" data-buy-close></div>
        <section class="buydrawer__panel" role="dialog" aria-modal="true" aria-labelledby="buyDrawerTitle">
          <button class="buydrawer__grabber" type="button" data-buy-close aria-label="Zamknij"></button>
          <h2 class="buydrawer__title" id="buyDrawerTitle">Twoje zamówienie</h2>

          <div class="buydrawer__line">
            <img class="buydrawer__img" id="buyFamilyImg" src="" alt="" />
            <div>
              <p class="buydrawer__name">StethoMe® Family</p>
              <p class="buydrawer__sub">Domowy Stetoskop + 12 miesięcy aplikacji</p>
            </div>
            <p class="buydrawer__price" id="buyFamilyPrice"></p>
          </div>

          <button class="buydrawer__upsell" type="button" role="switch" aria-checked="false" data-buy-upsell>
            <img class="buydrawer__img" src="${IMG_CASE}" alt="" />
            <span>
              <span class="buydrawer__tag">Zamień na zestaw</span>
              <span class="buydrawer__name">Dodaj etui StethoCase</span>
              <span class="buydrawer__sub">+ ${zl(CASE_PRICE)}<span class="buydrawer__strike">${zl(CASE_LIST)}</span></span>
            </span>
            <span class="buydrawer__switch" aria-hidden="true"></span>
          </button>

          <div class="buydrawer__total"><span>Razem</span><strong id="buyTotal"></strong></div>
          <p class="buydrawer__ship">Darmowa wysyłka · Bezpieczna płatność · 24 miesiące gwarancji</p>

          <p class="buydrawer__terms">Przechodząc dalej, potwierdzasz, że znasz <a href="/pages/regulamin-sklepu" target="_blank" rel="noopener">Regulamin sklepu</a> i <a href="/pages/polityka-prywatnosci" target="_blank" rel="noopener">Politykę prywatności</a> i akceptujesz Regulamin.</p>
          <p class="buydrawer__error" id="buyError" role="alert" hidden></p>
          <button class="buydrawer__accept" type="button" data-buy-accept>Akceptuję i przechodzę do płatności</button>
        </section>
      </div>`;
    document.body.appendChild(wrap.firstElementChild);
    drawer = document.getElementById("buyDrawer");
    upsell = drawer.querySelector("[data-buy-upsell]");
    total = document.getElementById("buyTotal");
    errorEl = document.getElementById("buyError");
    acceptBtn = drawer.querySelector("[data-buy-accept]");
  }

  const bundle = () => upsell.getAttribute("aria-checked") === "true";
  const refresh = () => { total.textContent = zl(cfg.familyPrice + (bundle() ? CASE_PRICE : 0)); };
  function showError(msg) { errorEl.hidden = !msg; errorEl.textContent = msg || ""; }

  function open(trigger) {
    if (!drawer) build();
    cfg = {
      family: parseInt(trigger.dataset.familyVariant, 10) || DEFAULTS.family,
      familyPrice: parseFloat(trigger.dataset.familyPrice) || DEFAULTS.familyPrice,
      familyImage: trigger.dataset.familyImage || IMG_FAMILY_FALLBACK,
      source: trigger.dataset.buySource || "Shopify – strona główna",
    };
    document.getElementById("buyFamilyImg").src = cfg.familyImage;
    document.getElementById("buyFamilyPrice").textContent = zl(cfg.familyPrice);
    upsell.setAttribute("aria-checked", "false");
    showError(null);
    acceptBtn.disabled = false;
    refresh();
    returnFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add("is-open")));
    document.body.classList.add("buydrawer-open");
    acceptBtn.focus();
  }

  function close() {
    drawer.classList.remove("is-open");
    document.body.classList.remove("buydrawer-open");
    setTimeout(() => { drawer.hidden = true; }, 360);
    if (returnFocus && returnFocus.focus) returnFocus.focus();
  }

  const post = (url, body) => fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(body || {}),
  });

  async function accept() {
    const withCase = bundle();
    const stamp = new Date().toISOString(); // chwila kliknięcia „Akceptuję…"
    acceptBtn.disabled = true;
    showError(null);
    try {
      let r = await post("/cart/clear.js");
      if (!r.ok) throw new Error("clear");
      const items = [{ id: cfg.family, quantity: 1 }];
      if (withCase) items.push({ id: CASE_VARIANT, quantity: 1 });
      r = await post("/cart/add.js", { items });
      if (!r.ok) throw new Error("add");
      r = await post("/cart/update.js", {
        attributes: {
          "Regulamin zaakceptowany": stamp,
          "Regulamin zaakceptowany (źródło)": cfg.source,
          "Wariant zamówienia": withCase ? "Zestaw: Family + StethoCase" : "Family",
        },
      });
      if (!r.ok) throw new Error("update");
      window.location.assign(withCase ? "/discount/" + DISCOUNT + "?redirect=" + encodeURIComponent("/checkout") : "/checkout");
    } catch (err) {
      acceptBtn.disabled = false;
      showError("Nie udało się przejść do płatności. Spróbuj ponownie.");
    }
  }

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-buy-drawer]");
    if (trigger) { e.preventDefault(); open(trigger); return; }
    if (!drawer) return;
    if (e.target.closest("[data-buy-upsell]")) { upsell.setAttribute("aria-checked", String(!bundle())); refresh(); return; }
    if (e.target.closest("[data-buy-close]")) { close(); return; }
    if (e.target.closest("[data-buy-accept]")) accept();
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && drawer && !drawer.hidden) close(); });
})();
